import React from "react"
import { Link } from "react-router-dom"

const SectionFour = () => {
  return (
    <div className="mt-24 text-center how-it-works pb-20">
      <div className="pb-20 pt-28 mobiles:pt-20 global-container">
        <h4 className="text-5xl sabi-header mobiles:text-4xl">How it works</h4>
        <p
          style={{ maxWidth: "800px" }}
          className="mt-8 mobiles:text-md leading-loose text-xl mx-auto"
        >
          No store had everything couples wanted. And no place recognized what
          engaged couple crave in a registry while planning their weddings.
        </p>
        <div className="mt-40 grid grid-cols-3 mobiles:block gap-8 h-60vh text-left">
          <div className="rounded-2xl mobiles:mb-12 mobiles:py-10 mobiles:text-center shadow-md h-full bg-white px-8">
            <img
              src={require("../../assets/one.svg").default}
              alt=""
              className="w-16 mt-20 mobiles:mx-auto block"
            />
            <h6 className="text-2xl sabi-header mt-8 font-semibold">
              Create an account
            </h6>
            <p className="mt-8">
              It’s free, fast, and won’t 30 seconds to <br /> create an account
              on Sabigift
            </p>
          </div>
          <div className="rounded-2xl mobiles:py-10 mobiles:mb-12 mobiles:text-center shadow-md h-full bg-white px-8">
            <img
              src={require("../../assets/two.svg").default}
              alt=""
              className="w-16 mt-20 mobiles:mx-auto block"
            />
            <h6 className="text-2xl sabi-header mt-8 font-semibold">
              Setup your event
            </h6>
            <p className="mt-8">
              Select an event from the various <br /> categories and provide
              information
            </p>
          </div>
          <div className="rounded-2xl mobiles:py-10 mobiles:text-center shadow-md h-full bg-white px-8">
            <img
              src={require("../../assets/three.svg").default}
              alt=""
              className="w-16 mt-20 mobiles:mx-auto block"
            />
            <h6 className="text-2xl sabi-header mt-8 font-semibold">
              Start receiving gifts
            </h6>
            <p className="mt-8">
              Get an event link to share and start <br /> receiving gifts from
              friends and family
            </p>
          </div>
        </div>
        <div className="mt-28 mobiles:mt-96 mobiles:relative mobiles:top-96 mobiles:translate-y-56 mobiles:transform">
          <Link
            to="/get-started"
            className=" py-2.5 px-11 ml-4 border border-sbg-pink text-sbg-pink text-transparent rounded-md text-base"
          >
            Get Started
          </Link>
        </div>
      </div>
    </div>
  )
}

export default SectionFour
